import { Menu } from 'antd'
import { useNavigate } from 'react-router-dom'

import { GetRouteUrlByKeyTask } from '@/Core/Tasks/UI/Menu/GetRouteUrlByKeyTask'

export type UserListKind = 'active' | 'inactive'

/**
 * Сторінки списку й запасні адреси, якщо генератор маршрутів ще не знає
 * ключа (`SPEC-002` §2.2).
 */
const ITEMS: Array<{ key: UserListKind; label: string; route: string; fallback: string }> = [
    { key: 'active', label: 'Активні співробітники', route: 'Setting.User', fallback: '/users' },
    { key: 'inactive', label: 'Деактивовані співробітники', route: 'Setting.UserInactive', fallback: '/users/inactive' },
]

/**
 * Верхнє меню «Співробітників» — як у легасі (`FU/Components/TopMenu.jsx`):
 * активні й деактивовані на двох сторінках, а не одним списком із фільтром
 * (`SPEC-005` С-13). Перша сторінка — корінь розділу, її відкриває пункт
 * бокового меню.
 */
export const UserTopMenu = ({ current }: { current: UserListKind }) => {
    const navigate = useNavigate()

    return (
        <Menu
            mode="horizontal"
            selectedKeys={[current]}
            style={{ marginBottom: 16 }}
            items={ITEMS.map(({ key, label }) => ({ key, label }))}
            onClick={({ key }) => {
                const item = ITEMS.find((candidate) => candidate.key === key)

                if (item) navigate(GetRouteUrlByKeyTask(item.route) || item.fallback)
            }}
        />
    )
}
